import React from 'react';
import PlusOneIcon from '@material-ui/icons/PlusOne';
import ListAltIcon from '@material-ui/icons/ListAlt';
import TelegramIcon from '@material-ui/icons/Telegram';
import { DetailToolbarButtonMenuItem } from '@eas/common-web';
import { useRedirect } from './actions/redirect-hook';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import { SvgIconTypeMap } from '@material-ui/core';
import { DetailToolbarButtonMenu } from '../../components/evidence/evidence/detail-toolbar-button-menu';

type IconType = OverridableComponent<
  SvgIconTypeMap<Record<string, unknown>, 'svg'>
>;

function useToolbarItems() {
  /**
   * Array of SUBJECT ACTIONS.
   */
  const actionItems: DetailToolbarButtonMenuItem[] = [];

  const addAction = (label: string, Icon: IconType, onClick: () => void) =>
    actionItems.push({
      label,
      Icon: <Icon fontSize="small" htmlColor="black" />,
      onClick,
    });

  /**
   * Redirect actions.
   */
  const {
    handleNewRequest,
    handleShowRequests,
    handleRedirectToRequest,
    redirectToRequestButtonVisible,
  } = useRedirect();

  addAction('Nová žádost o zmocnění', PlusOneIcon, handleNewRequest);
  addAction('Přehled žádostí o zmocnění', ListAltIcon, handleShowRequests);
  if (redirectToRequestButtonVisible) {
    addAction('Žádost', TelegramIcon, handleRedirectToRequest);
  }

  return {
    actionItems,
  };
}

export function EmpowermentToolbar() {
  const { actionItems } = useToolbarItems();

  return (
    <>
      <DetailToolbarButtonMenu label="Otevřít" items={actionItems} />
    </>
  );
}
